/**
 * 描述：开关组件
 * 日期：2017-7-3
 * 作者：bai.zhiming
 */
"use strict";
angular.module("trsSwitchModule", [])
    .directive("trsSwitch", ["$timeout", function($timeout) {
        return {
            restrict: "E",
            replace: false,
            templateUrl: "./util/trsSwitch/trsSwitch_tpl.html",
            scope: {
                status: "=",
                callback: "&",
                disabled: "=",
                label: "@",
                name: "@",
                value: "=" //开关打开时左侧显示的文字（限1个汉字）
            },
            link: function(scope, element, attrs, controller) {
                if (typeof scope.status === "undefined") {
                    scope.status = false;
                }
                scope.label = scope.label || "";
                scope.name = scope.name || "";
                scope.value = scope.value || "";
                if (scope.disabled) {
                    return false;
                }
                scope.swtichBtn = function() {
                    $timeout(function() {
                        scope.callback();
                    });
                };
            }
        };
    }]);
